import React from 'react'
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import {
    UiContentWr,
    UiContentCol,
    UiColTitle
} from "../../components/common/UiPageElements";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import Footer from "../../components/footer/Footer";
import UiHowCampaignsWork from "../../components/common/UiHowCampaignsWork";
import IncentiveBanner from './views/IncentiveBanner';
import nyImage from "../../../../styles/img/ttny.jpg";
import nyImage2 from "../../../../styles/img/ttny-2.jpg";
import nyImage3 from "../../../../styles/img/ttny-3.jpg";
import nyImage4 from "../../../../styles/img/ttny-4.jpg";
import { Button, Table } from "react-bootstrap";
import { UiCardTitle } from '../../components/common/UiCardTitle';
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import { TripFeatures } from './views/TripFeatures';
import { HowIncentiveWorks } from './views/QuickRead';
import { TermsConditions } from './views/TermsConditions';
import { Faq } from './views/Faq';
import UiIncentiveHistoryCard from '../../components/common/UiIncentiveHistoryCard';
import { UiSalesChainElement, UiSalesChainElementNoBgWr } from '../../components/common/UiSalesChainElements';
import { GreenRoundedTick } from '../../../../styles/img/svg/GreenRoundedTick';
import { UiTable } from '../../components/common/UiTable';
import Avatar from '../../../../styles/img/Avatar.png';
import sliderCardImage from '../../../../styles/img/slider-card.jpg';
import { TickIcon } from '../../../../styles/img/svg/TickIcon';
import { UiLeftContentRightImageBlock } from '../../components/common/UiImageBlock';
import { UiStatusBottom } from '../../components/common/UiStatusBarBottom';
import { OrangeHeartIcon } from '../../../../styles/img/svg/OrangeHeartIcon';
import { HowtoParticipate } from './views/HowtoParticipate';
import { UiInput } from '../../components/form/UiInput';
import { UiButtonPrimary } from '../../components/form/UiButton';


export default function IncentivesPrizeDrawWinner(props) {

    const TableHeaders = [
        { id: 1, th: 'Name' },
        { id: 2, th: 'Location' },
        { id: 3, th: 'Department' },
        { id: 4, th: 'Prizes' },
    ];


    const wizardData = [
        { id: 1, number: "1", title: 'Step 1', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.', status: 'active' },
        { id: 2, number: "2", title: 'Step 2', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.' },
        { id: 3, number: "3", title: 'Step 3', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.' },
        { id: 3, number: "4", title: 'Step 4', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.' },
        { id: 5, number: <TickIcon />, title: 'Success', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.', status: "success" },
    ];


    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <IncentiveBanner
                    topText="Incentive"
                    title="Trip to NY
                5 Days All Inc"
                    description="Lorem Epsum You’re already working hard, enjoy
                various rewards you, your team and your family can enjoy."
                    sliderCardImage={sliderCardImage}
                />

                <UiBannerBottomBar
                    prevPage="Campaigns"
                    prevPageLink="/ui"
                    currentPage="Sell 15 Premium Tickets"
                    currentPageLink="/ui/incentives-pre-register"
                />

                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentCol>
                                <UiLeftContentRightImageBlock
                                    image1={nyImage}
                                    image2={nyImage2}
                                    image3={nyImage3}
                                    image4={nyImage4}
                                >
                                    <UiCardTitle title="Trip to New York!" />
                                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>

                                    <hr />

                                    <h3>Win up to 20 Points</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu
                                    </p>

                                    <Button to="" className="sb-primary-btn--38">Join Incentive</Button>
                                </UiLeftContentRightImageBlock>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <HowtoParticipate wizardData={wizardData} className="sb-ins-lg-wiz-4step" />
                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="6" className="sb-add-new-entry mt-2">
                            <h3>Entry Closed</h3>
                            <h5>Lorem Epsum</h5>
                            <div className='sb-entry-closed'></div>
                                <UiContentCol>
                                    <h6>New Entry</h6>
                                    <span>Enter Sales Reference Below</span>
                                    <UiInput />
                                    <UiButtonPrimary btnName="Validate & Enter" />
                                </UiContentCol>
                        </UiCol>
                        <UiCol lg="6" className="sb-new-entries mt-2">
                            <h3>Your Entries For This Prize Draw Only</h3>
                            <h5>10 entries confirmed. 2 verifying</h5>
                            <UiContentCol>
                                <UiSalesChainElementNoBgWr>
                                    <UiSalesChainElement isEntryActive={true} salesStatus="Entry confirmed for sale" salesId="NR7107463" date="22 Nov 2022" />
                                    <UiSalesChainElement isEntryActive={true} salesStatus="Entry confirmed for sale" salesId="NR7107463" date="22 Nov 2022" />
                                    <UiSalesChainElement isEntryActive={true}  salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                    <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                    <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />

                                </UiSalesChainElementNoBgWr>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
            
                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-league-tabl-sec">
                        <UiCol lg="12">

                            <UiContentCol>
                                <UiSingleRow>
                                    <UiCol lg="12">
                                        <div className='sb-league-tabl-sec__header sb-prize-draw-table-header'>
                                            <h2> Announcing the winners</h2>
                                            <p>The following prizes have now been allocated</p>
                                        </div>
                                    </UiCol>
                                    <UiCol lg="12" xl="8">
                                        <div className='sb-league-tabl-sec__incentive-joined-sec'>
                                            <UiTable className="sb-white-bg-table sb-white-bg-prize-draw-table" tableHeader={TableHeaders}>
                                                <tr>
                                                    <td>
                                                        <div>
                                                            <img src={Avatar} />
                                                            <span>
                                                                <h4>Brad Simmons</h4>
                                                                <p>Lorem Epsum</p>
                                                            </span>

                                                        </div>
                                                    </td>
                                                    <td >
                                                        <h4>London</h4>
                                                        <p>UK</p>
                                                    </td>
                                                    <td>
                                                        <h4>Intertico</h4>
                                                        <p>Sales</p>
                                                    </td>
                                                    <td >
                                                        <h4>Holiday</h4>
                                                        <p>France</p>
                                                    </td>
                                                
                                                </tr>

                                                <tr>
                                                   
                                                    <td>
                                                        <div>
                                                            <img src={Avatar} />
                                                            <span>
                                                                <h4>Brad Simmons</h4>
                                                                <p>Lorem Epsum</p>
                                                            </span>

                                                        </div>
                                                    </td>
                                                    <td >
                                                        <h4>London</h4>
                                                        <p>UK</p>
                                                    </td>
                                                    <td>
                                                        <h4>Intertico</h4>
                                                        <p>Sales</p>
                                                    </td>
                                                    <td >
                                                        <h4>Holiday</h4>
                                                        <p>France</p>
                                                    </td>
                                                </tr>

                                                <tr>
                                                  
                                                    <td>
                                                        <div>
                                                            <img src={Avatar} />
                                                            <span>
                                                                <h4>Brad Simmons</h4>
                                                                <p>Lorem Epsum</p>
                                                            </span>

                                                        </div>
                                                    </td>
                                                    <td >
                                                        <h4>London</h4>
                                                        <p>UK</p>
                                                    </td>
                                                    <td>
                                                        <h4>Intertico</h4>
                                                        <p>Sales</p>
                                                    </td>
                                                    <td >
                                                        <h4>Holiday</h4>
                                                        <p>France</p>
                                                    </td>
                                                </tr>

                                                <tr>
                                                  
                                                    <td>
                                                        <div>
                                                            <img src={Avatar} />
                                                            <span>
                                                                <h4>Brad Simmons</h4>
                                                                <p>Lorem Epsum</p>
                                                            </span>

                                                        </div>
                                                    </td>
                                                    <td >
                                                        <h4>London</h4>
                                                        <p>UK</p>
                                                    </td>
                                                    <td>
                                                        <h4>Intertico</h4>
                                                        <p>Sales</p>
                                                    </td>
                                                    <td >
                                                        <h4>Holiday</h4>
                                                        <p>France</p>
                                                    </td>
                                                </tr>

                                                


                                            </UiTable>
                                        </div>

                                        
                                    

                                    </UiCol>
                                    <UiCol lg="12" xl="4" className="sb-your-prize">
                                        <h4>Your prize</h4>
                                        <p>If you are amongst the winners....,.consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu
                                        </p>
                                    </UiCol>
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>



                <Faq />

                <Footer />

            </UiMainWrapper>
        </>
    )
}



